<div class="icons-standalone-container">
  <div class="search-header">
    <input type="text" class="search-input" placeholder="Pesquisar ícones..." [(ngModel)]="searchTerm">
    <div class="icons-count">{{ filteredIcons.length }} ícones encontrados</div>
  </div>

  <div class="icons-grid">
    <div class="icon-card" *ngFor="let icon of filteredIcons" (click)="copyToClipboard(icon.name)" [title]="'Clique para copiar: ' + icon.name">
      <div class="icon-preview">
        <svg-icon [name]="icon.name" [svgStyle]="{ 'width.px':32, 'height.px':32, 'fill':'#333' }"></svg-icon>
      </div>
      <div class="icon-name">{{ icon.name }}.svg</div>
    </div>
  </div>
</div>
